import { render } from "./Modalv.vue?vue&type=template&id=1c57da27&scoped=true&bindings={\"shared\":\"options\",\"format\":\"setup\",\"marked\":\"setup\",\"email\":\"props\"}"
import script from "./Modalv.vue?vue&type=script&lang=js"
export * from "./Modalv.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1c57da27"

export default script